import * as React from "react";

import { style, MyIconProps } from "./MyIcons";

export const ClockStopwatch = (props: MyIconProps): React.ReactElement => {
  return (
    <svg
      ref={props.elementRef}
      className={props.className}
      style={{ ...style(props), ...props.style }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <path d="M10 2H14" />
      <path d="M17.6569 7.34314C20.7811 10.4673 20.7811 15.5327 17.6569 18.6568C14.5327 21.781 9.46739 21.781 6.3432 18.6568C3.21901 15.5327 3.21901 10.4673 6.3432 7.34314C9.46739 4.21895 14.5327 4.21895 17.6569 7.34314" />
      <path d="M11.999 8.00002C11.864 8.00002 11.755 8.10902 11.756 8.24402C11.756 8.37902 11.865 8.48802 12 8.48802C12.135 8.48802 12.244 8.37902 12.244 8.24402C12.244 8.10902 12.135 8.00002 11.999 8.00002" />
      <path d="M11.999 17.512C11.864 17.512 11.755 17.621 11.756 17.756C11.756 17.891 11.865 18 12 18C12.135 18 12.244 17.891 12.244 17.756C12.244 17.621 12.135 17.512 11.999 17.512" />
      <path d="M17 12.999C17 12.864 16.891 12.755 16.756 12.756C16.621 12.756 16.512 12.865 16.512 13C16.512 13.135 16.621 13.244 16.756 13.244C16.891 13.244 17 13.135 17 12.999" />
      <path d="M7.488 12.999C7.488 12.864 7.379 12.755 7.244 12.756C7.109 12.756 7 12.865 7 13C7 13.135 7.109 13.244 7.244 13.244C7.379 13.244 7.488 13.135 7.488 12.999" />
      <path d="M15.535 9.46402C15.44 9.36902 15.285 9.36902 15.191 9.46502C15.096 9.56002 15.096 9.71502 15.191 9.81002C15.286 9.90502 15.441 9.90502 15.536 9.81002C15.631 9.71402 15.631 9.56002 15.535 9.46402" />
      <path d="M8.80901 16.19C8.71401 16.095 8.55901 16.095 8.46501 16.191C8.37001 16.286 8.37001 16.441 8.46501 16.536C8.56001 16.631 8.71501 16.631 8.81001 16.536C8.90501 16.441 8.90501 16.286 8.80901 16.19" />
      <path d="M15.536 16.535C15.631 16.44 15.631 16.285 15.535 16.191C15.44 16.096 15.285 16.096 15.19 16.191C15.095 16.286 15.095 16.441 15.19 16.536C15.286 16.631 15.44 16.631 15.536 16.535" />
      <path d="M8.81 9.80901C8.905 9.71401 8.905 9.55901 8.809 9.46501C8.714 9.37001 8.559 9.37001 8.464 9.46501C8.369 9.56001 8.369 9.71501 8.464 9.81001C8.559 9.90501 8.714 9.90501 8.81 9.80901" />
    </svg>
  );
};
